export default __webpack_public_path__ + "static/media/berseem.31480262.png";